<template>
    <div id="page-user-edit" class="flex items-center justify-center min-h-screen bg-gray-100 bg-img">
      <vx-card class="w-full max-w-lg p-6 shadow-lg rounded-lg bg-white">
        <div slot="no-body" class="tabs-container">
          <!-- Logo en haut de la carte -->
          <div class="flex justify-center mb-6">
            <img src="https://xylo.codesinn.com/logo-xylo-impact.svg" alt="Logo XYLO Impact" class="h-16">
          </div>
          <div class="flex justify-center mb-6">
            <h2 class="text-xl font-semibold">Chestionar pentru șoferi</h2>
          </div>
  
  
          <div slot="no-body" class="tabs-container">
            <div class="tab-text">
              <div id="user-edit-tab-info">
                <!-- Content Row -->
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div class="flex flex-col space-y-4">
                      <!-- Informations du Chauffeur -->
                      <div class="flex flex-col md:flex-row md:space-x-4">
                        <div class="flex-1">
                          <vs-input label="Transport Code" v-model="transportid" class="w-full" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <!-- Bouton Enregistrer -->
                <div class="vx-row mt-6">
                  <div class="vx-col w-full">
                    <div class="flex justify-end">
                      <vs-button color="success" @click="save_changes">
                        Open
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </template>
  
  
  
  <script>
  import vSelect from "vue-select";
  import axios from "@/axios.js";
  import Datepicker from "vuejs-datepicker";
  import moduleOperationList from "@/store/operation/moduleOperationList.js";
  import moment from "moment";
  
  export default {
    components: {
      vSelect,
      Datepicker,
    },
    data() {
      return {
        transportid: null
      };
    },
    methods: {
      save_changes() {
          this.$router.push("/transporter/forms/"+this.transportid);
        }
      },
  
    created() {
      if (!moduleOperationList.isRegistered) {
        this.$store.registerModule("operationList", moduleOperationList);
        moduleOperationList.isRegistered = true;
      }
    },
    mounted() {
      this.isMounted = true;
    },
  }
  </script>
  